<app-form-select-single-v2
  [(ngModel)]="value"
  [options]="options"
  clearable="true"
  (blurEvent)="stopEditing()">
</app-form-select-single-v2>
